module.exports = __webpack_public_path__ + "img/anguilla.94393762.svg";